<script setup>
import { DmIconButton, DmTag, Icon, List, ListBody, ListCell, ListColumn, ListHeader, ListRow } from 'dmui_components'
import { ENTITY, VALUE_STREAMS_MAPPING } from '../vars/mappings.js'

defineProps({
	iros: {
		type: Array,
		default: undefined
	},
	readonly: {
		type: Boolean,
		default: false
	}
})

defineEmits(['delete'])
</script>
<template>
	<List>
		<ListHeader>
			<ListColumn>Iro*</ListColumn>
			<ListColumn>Description*</ListColumn>
			<ListColumn>Page</ListColumn>
			<ListColumn>Entity-specific topic*</ListColumn>
			<ListColumn>Value stream</ListColumn>
			<ListColumn></ListColumn>
		</ListHeader>
		<ListBody>
			<slot>
				<ListRow v-if="!iros?.length">
					<ListCell colspan="6" class="empty-state">No entity-specific IROs</ListCell>
				</ListRow>
				<ListRow v-for="iro in iros" :key="iro.id">
					<ListCell><component :is="ENTITY[iro.iro]" size="medium" /></ListCell>
					<ListCell>{{ iro.description }}</ListCell>
					<ListCell>{{ iro.page }}</ListCell>
					<ListCell>{{ iro.entity_specific_topic }}</ListCell>
					<ListCell class="value-chains">
						<DmTag v-for="valueChain in iro.value_chains" :key="valueChain" class="important">
							<Icon name="uil-mountains" size="mini" />
							{{ VALUE_STREAMS_MAPPING[valueChain] }}
						</DmTag>
					</ListCell>
					<ListCell>
						<DmIconButton
							v-if="!readonly"
							:id="`${iro.id}-delete-entity-specific-button`"
							class="secondary transparent slim"
							icon="uil-trash-alt"
							icon-size="midi"
							@click="$emit('delete', iro.id)">
							Delete Iro
						</DmIconButton>
					</ListCell>
				</ListRow>
			</slot>
		</ListBody>
	</List>
</template>

<style scoped lang="less">
:deep(tbody tr):hover {
	background-color: @gray-10;
}

:deep(td):first-child {
	padding-left: @micro !important;
}
:deep(td):last-child {
	padding-right: @micro !important;
}
:deep(td):not(:last-child) {
	padding-right: @midi !important;
}

:deep(td),
:deep(th) {
	&:nth-child(1) {
		width: 50px;
	}
	&:nth-child(2) {
		min-width: 250px;
		max-width: 250px;
	}
	&:nth-child(3) {
		min-width: 50px;
		max-width: 50px;
	}
}

.value-chains {
	display: flex;
	flex-direction: column;
	gap: @micro;
}

.empty-state {
	color: @gray-60;
	font-style: italic;
}
</style>
